module.exports = __webpack_public_path__ + "img/Proactivity_Gold.7935d74d.png";